export default {
  tradeIn: {
    id: 'cart_add_to_cart_page_trade_in',
    defaultMessage: 'Trade-in',
  },
}
